import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 55px;
  width: 100%;
`;

export const Label = styled.p`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--brand-primary);
  margin: 0 0 12px 0;
  text-align: left;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;
